import './main-spinner.scss';

import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

interface IProps {
  fullWidth?: boolean;
  fullScreen?: boolean;
}

const MainSpinner: React.FC<IProps> = ({ fullWidth, fullScreen }) => {
  const rootClasses = [
    'main-spinner',
    fullWidth ? 'main-spinner--full-width' : '',
    fullScreen ? 'main-spinner--fullscreen' : ''
  ].join(' ');

  return (
    <div className={rootClasses}>
      <Spin indicator={<LoadingOutlined spin />} size="large" />
    </div>
  );
};

export default MainSpinner;
